import React from "react";
import { Text, StyleSheet, View, Platform } from "react-native";

import AppTheme from "../../../AppTheme";
import ElementIcon from "../../../elements/list/ElementIcon";

export default function ComparisonElement({ element }) {
  return (
    <View style={styles.elementContainer}>
      <ElementIcon
        style={styles.icon}
        element={{
          icon: element?.icon,
          name: element?.name,
        }}
      />

      <View style={{ marginBottom: 6 }}>
        <Text style={styles.headerText} numberOfLines={1}>
          {element.name}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  elementContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 4,
  },
  icon: {
    width: 24,
    height: 24,
    marginRight: 6,
  },
  headerText: {
    paddingTop: 10,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
});
